import { v4 as uuid4 } from 'uuid';

const data = [
    {
        id: uuid4(),
        title: "Автоматизация бизнес-процессов",
        active: true
    },
    {
        id: uuid4(),
        title: "Привлечение новых клиентов",
        active: true
    },
    {
        id: uuid4(),
        title: "Увеличение прибыли",
        active: true
    },
    {
        id: uuid4(),
        title: "Ускорение принятия решений",
        active: true
    },
    {
        id: uuid4(),
        title: "Рост эффективности",
        active: true
    },
    {
        id: uuid4(),
        title: "Повышение лояльности",
        active: true
    },
]

export default data